import React from 'react';
import { format, parseISO } from 'date-fns';
import { LastTagOperationDto } from './rateToolsSlice';
import {
  SEASON_RATE_BATCH_OPERATION_TYPE,
  SEASON_RATE_BATCH_OPERATION_TYPE_DESCRIPTIONS,
} from '../../common/constants';

interface LastTagOperationInfoProps {
  lastOperation: LastTagOperationDto | null;
}

const LastTagOperationInfo = ({ lastOperation }: LastTagOperationInfoProps) => {
  if (!lastOperation) return null;

  const operationDate = format(
    parseISO(lastOperation.operationDate),
    'dd.MM.yyyy HH:mm',
  );
  const operationLabel =
    SEASON_RATE_BATCH_OPERATION_TYPE_DESCRIPTIONS[
      lastOperation.operationType
    ] ?? lastOperation.operationType;

  return (
    <div className="mt-16 p-12 bg-light border rounded small text-muted">
      <strong>Edellinen ajo:</strong> {operationLabel} — {operationDate}
      {lastOperation.operationType ===
        SEASON_RATE_BATCH_OPERATION_TYPE.SeasonRateCopying &&
        lastOperation.copiedUpToDate && (
          <span>
            {' '}
            — kopioitu{' '}
            <strong>
              {format(parseISO(lastOperation.copiedUpToDate), 'dd.MM.yyyy')}
            </strong>{' '}
            asti
          </span>
        )}
    </div>
  );
};

export default LastTagOperationInfo;
